import { render, staticRenderFns } from "./AddIdentityForm.vue?vue&type=template&id=62e4205a&scoped=true&"
import script from "./AddIdentityForm.vue?vue&type=script&lang=ts&"
export * from "./AddIdentityForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddIdentityForm.vue?vue&type=style&index=0&id=62e4205a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e4205a",
  null
  
)

/* custom blocks */
import block0 from "./AddIdentityForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports